<div class="">
  <div class="container">
    <div class="left-section">
      <h2>Sign In</h2>
      <p>to access TripMeld</p>

      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <div class="form-group ">
          <input type="email" formControlName="email" class="form-control" placeholder="Email ID"
            [ngClass]="{'is-invalid': loginForm.get('email')?.invalid && loginForm.get('email')?.touched}" />
          <div class="text-danger warning-message"
            *ngIf="loginForm.get('email')?.invalid && loginForm.get('email')?.touched">
            Require/Invalid
          </div>
        </div>

        <!-- Password Input -->
        <div class="input-block1 d-flex align-items-center">
          <i class="icon me-2 bi bi-lock"></i>
          <ion-input type="password" formControlName="password" class="mail-password" placeholder="Password"
            [ngClass]="{'is-invalid': loginForm.get('password')?.invalid && loginForm.get('password')?.touched}">
            <ion-input-password-toggle slot="end"></ion-input-password-toggle>
          </ion-input>
        </div>
        <div class="warning-message" *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
          Require/Invalid
        </div>


        <div class="text-danger" *ngIf="expired">
          The user's session has expired. Please log in again.
        </div>

        <div class="text-danger" *ngIf="errorMessage">
          <p class="mb-0 text-danger">{{ errorMessage }}</p>
        </div>

        <div class="options mb-3">
          <label class="remember-me">
            <input type="checkbox" id="rememberMe" [checked]="rememberMe" (input)="toggleRememberMe($event)" /> Remember
            Me
          </label>
          <a (click)="forgotPassword()" style="cursor: pointer">Forgot Password?</a>
        </div>

        <button class="sign-in-btn" type="submit">Sign in</button>

        <div class="sign-up-link">
          <p>
            Don't have an account?
            <a routerLink="/sign-up">Sign up</a>
          </p>
        </div>

      </form>
    </div>

    <div class="right-section">
      <div class="right-main-container bg-cover">
        <div class="img-container">
          <img src="assets/Images/sign-in.png" alt="" class="img">
          <!-- ABS images -->
          <img src="assets/Images/circles-cylinder.gif" alt="" class="circles-1-gif">
          <img src="assets/Images/circles-cylinder.gif" alt="" class="circles-2-gif">
          <img src="assets/Images/arrow-tick.gif" alt="" class="arrow-gif">
        </div>
      </div>
      <div class="paras-align">
        <h2>Welcome To Your TripMeld CRM</h2>
        <p>Streamline operations, enhance customer experiences, and manage everything in one place.</p>
      </div>
    </div>
  </div>

  <app-spinner *ngIf="showSpinner"></app-spinner>
</div>